import planningsWatcher from '@spa/scenes/Plannings/redux/modules/watcher/planningsWatcher'

import controllersSlice from './modules/controllers/controllersSliceSaga'
import entitiesSlice from './modules/entities'

export default [entitiesSlice(), controllersSlice(), planningsWatcher()]
